import _                                                from 'underscore';
import React                                            from 'react';
import { Button, ButtonProps, Dropdown, DropdownProps } from "semantic-ui-react";
import { CorvalUIColor, SemanticUIColor }               from "@src/types";
import { Cell, Grid }                                   from "styled-css-grid";
import classNames                                       from "classnames";
import { runIfFunction }                                from "@src/util";
import { DotShape }                                     from '@src/views/components/util/visual/DotShape';
import { StyledContainer }                              from '@src/views/containers';
import { PROJECT_ENTITY_SUPPORTED_COLORS }              from "@src/constants";


interface ColorMenuProps {
    value: SemanticUIColor | CorvalUIColor,
    colorOptions: Array<SemanticUIColor | CorvalUIColor>,
    gridSize: number,
    cellWidth: number,
    triggerDotSize: number,
    sampleDotSize: number,
    activeColor?: SemanticUIColor,
    inactiveColor?: SemanticUIColor,
    triggerButtonProps?: ButtonProps,
    dropdownProps?: Partial<DropdownProps>,
    includeDefaultColors?: boolean,

    onClick( value: SemanticUIColor | CorvalUIColor ): void,
}

const ColorMenuDefaultProps = {
    value:                SemanticUIColor.GREY,
    colorOptions:         [],
    gridSize:             3,
    cellWidth:            30,
    triggerDotSize:       17,
    sampleDotSize:        24,
    activeColor:          SemanticUIColor.PURPLE,
    inactiveColor:        SemanticUIColor.GREY,
    triggerButtonProps:   {},
    dropdownProps:        {},
    includeDefaultColors: true,
    onClick:              null,
} satisfies Partial<ColorMenuProps>;



function ColorMenu( _props: ColorMenuProps ){

    const props = { ...ColorMenuDefaultProps, ..._props };

    const { gridSize, cellWidth } = props;

    const handleOnClick = ( value: SemanticUIColor | CorvalUIColor ) => {

        runIfFunction( props.onClick, value );
    };

    const colorOptions = ( _.uniq( [ ...( props.includeDefaultColors ? PROJECT_ENTITY_SUPPORTED_COLORS : [] ), ...props.colorOptions ] ) as Array<SemanticUIColor | CorvalUIColor> );

    return (
        <Dropdown
            icon={ null }
            trigger={
                <Button type={ 'button' } icon basic { ...props.triggerButtonProps }>

                    <DotShape size={ props.triggerDotSize } color={ props.value }/>

                </Button>
            }
            { ...props.dropdownProps }>

            <Dropdown.Menu>

                <Grid columns={ `repeat(${ gridSize }, ${ cellWidth }px)` }
                      rows={ `repeat(${ Math.ceil( colorOptions.length / gridSize ) }, ${ cellWidth }px)` }
                      className={ 'padding-xs' }
                      style={ {
                          boxSizing: 'content-box'
                      } }
                      gap={ `5px` }>

                    { colorOptions.map( ( colorOption, index ) => {

                        const isActive = colorOption === props.value;

                        return (

                            <Cell middle center key={ colorOption }
                                  onClick={ () => handleOnClick( colorOption ) }
                                  className={ classNames( {
                                      'cursor--pointer':                               !isActive,
                                      'outline-sm':                                    true,
                                      'outline--hover':                                !isActive,
                                      [ `outline--colored-${ props.activeColor }` ]:   isActive,
                                      [ `outline--colored-${ props.inactiveColor }` ]: !isActive,
                                  } ) }>

                                <StyledContainer style={ {
                                    width:          `${ cellWidth }px`,
                                    height:         `${ cellWidth }px`,
                                    display:        'flex',
                                    justifyContent: 'center',
                                    alignItems:     'center',
                                } }>

                                    <DotShape size={ props.sampleDotSize } color={ colorOption }/>

                                </StyledContainer>

                            </Cell>
                        );
                    } )
                    }
                </Grid>

            </Dropdown.Menu>
        </Dropdown>
    );
}

export {
    ColorMenu,
    ColorMenuDefaultProps,
    type ColorMenuProps,
};
